/* tslint:disable */
import { VariabelLine } from './variabel-line';

/**
 */
export class ViewLineList {
    dataResultExist?: VariabelLine;
    dataResult?: VariabelLine;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-line-list.ts